import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RideDemandsDetailScreen from './screens/RideDemandsDetailScreen';
import RideDemandsListScreen from './screens/RideDemandsListScreen';

function RideDemands() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RideDemandsListScreen />} />
          <Route path=":demandId" element={<RideDemandsDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RideDemands;
